var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-sm btn-default",attrs:{"disabled":_vm.loading,"type":"button"},on:{"click":_vm.createGhostUser}},[(_vm.loading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Continue As Guest\n    ")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73c4b608","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Users/LoginOrSignup/GuestLogin.vue
// module id = 846
// module chunks = 1 2